var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 5.96V4.375C8.75 2.99521 9.87021 1.875 11.25 1.875H12.1875C12.36 1.875 12.5 2.01503 12.5 2.1875V3.125C12.5 4.50479 11.3798 5.625 10 5.625C8.62021 5.625 7.5 6.74521 7.5 8.125C7.5 9.375 8.125 10 8.125 11.25C8.125 11.9262 7.90569 12.5841 7.5 13.125M2.5 5.625C3.44693 4.9148 4.71384 4.80057 5.77254 5.32992C6.83124 5.85927 7.5 6.94134 7.5 8.125C6.55307 8.8352 5.28616 8.94943 4.22746 8.42008C3.16876 7.89073 2.5 6.80866 2.5 5.625M3.125 13.125H11.875",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoot);
export default __webpack_public_path__ + "static/media/root.b30049b78fd3d5344e2bda620b9d2aa4.svg";
export { ForwardRef as ReactComponent };